import { useRef } from 'react'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { preventDefault } from '../../../utils/events'
import {
  GRETA_AI_CHAT_SOURCES,
  GretaAIChatSource,
  QA_NAME_GRETA_AI_CHAT_SOURCE_SWITCH,
} from '../GretaAIChat.constants'
import { getGretaAIChatOtherSource } from '../GretaAIChat.utils.source'

import { getIsGretaAIChatSourceSwitchKey } from './GretaAIChatSourceSwitch.utils'
import { GretaAIChatSourceSwitchOption } from './GretaAIChatSourceSwitchOption'

import * as styles from './GretaAIChatSourceSwitch.module.css'

function GretaAIChatSourceSwitch({
  canSwitch = false,
  className = styles.switch,
  isFinanceNotBought = false,
  isPinned = false,
  source = GretaAIChatSource.Crm,
  onSelect = EMPTY_FUNCTION,
}) {
  // Set by an arrow key and taken by the option it selects, so other selections never move focus.
  const keyboardSelectRef = useRef(false)

  function handleKeyDown(event) {
    if (canSwitch && getIsGretaAIChatSourceSwitchKey(event.key)) {
      preventDefault(event)
      keyboardSelectRef.current = true
      onSelect(getGretaAIChatOtherSource(source))
    }
  }

  const qaProps = getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_SOURCE_SWITCH })

  return (
    <div {...qaProps} className={className}>
      {GRETA_AI_CHAT_SOURCES.map(item => (
        <GretaAIChatSourceSwitchOption
          canSwitch={canSwitch}
          isFinanceNotBought={isFinanceNotBought}
          isPinned={isPinned}
          key={item}
          keyboardSelectRef={keyboardSelectRef}
          selectedSource={source}
          source={item}
          onKeyDown={handleKeyDown}
          onSelect={onSelect}
        />
      ))}
    </div>
  )
}

export default GretaAIChatSourceSwitch
